export default {
    title: 'Custom Table',
    'title-plural': 'Custom Tables',
    create: 'Create Table',
    import: {
        button: 'Import from JSON',
        title: 'Import Custom Table from JSON',
        paste: 'Paste JSON here...',
    },
    'configure-record-view': 'Configure Record Views',
    'show-records': 'Show Records',
    'export-tables': 'Export Custom Tables',
    export: 'Export',
    'import-button': 'Import',
    'download-as-json': 'Download as JSON',
    'copy-to-clipboard': 'Copy to clipboard',
    'copied-to-clipboard': 'Copied to clipboard',
    'exported-successfully': 'Exported successfully',
    'imported-successfully': 'Imported successfully',
    'import-failed': 'Import failed',
    'import-record-view': {
        title: 'Import Record View Configuration',
        'upload-label': 'Import via JSON file',
        'upload-description': 'Upload a JSON file containing your record view configuration',
        'paste-label': 'Paste JSON here...',
    },
    fields: {
        fields: 'Fields',
        'relation-fields': 'Relation Fields',
        'add-relation-fields-info': 'Relation Fields can be defined once the relation has been created.',
        title: 'Objects',
        create: 'Add object',
        'edit-field': 'Edit field',
        'add-field': 'Add field',
        'search-fields': 'Search fields',
        empty: 'No fields found.',
    },
    'add-field': {
        icon: 'Icon',
        type: 'Type',
        name: 'Name',
        label: 'Label',
        readonly: 'Readonly',
        'default-value': 'Default value',
        'default-current-date': 'Default to Current Date',
        'default-current-date-time': 'Default to Current Date and Time',
        'default-checkbox': 'Selected',
        'default-single-select': 'Default option',
        'default-multi-select': 'Default options',
        'max-length': 'Max length',
        autoincrement: 'Autoincrement',
        'button-name': 'Button name',
        'button-label': 'Button Label',
        workflow: 'Workflow',
        'select-workflow': 'Select workflow',
    },
    'delete-selected-fields': 'Delete selected fields',
    'delete-selected-relations': 'Delete selected relations',
    'on-off-options': {
        yes: 'Yes',
        no: 'No',
    },
    'create-new': 'Create New Custom Table',
    edit: 'Edit {name}',
    empty: 'No tables found.',
    name: 'Name',
    'label-singular': 'Label Singular',
    'label-plural': 'Label Plural',
    description: 'Description',
    'record-label': 'Record Label',
    actions: 'Actions',
    'table-view': {
        'add-new': 'Add new {name}',
        'table-not-editable': 'Add new field to the custom table to make it editable',
    },
    relations: {
        title: 'Relations',
        add: 'Add relation',
        icon: 'Icon',
        type: 'Type',
        name: 'Name',
        label: 'Label',
        table: 'Table',
        'relation-type': 'Relation Type',
        'one-to-many': 'One to Many',
        'many-to-one': 'Many to One',
        'many-to-many': 'Many to Many',
        'one-to-one': 'One to One',
        'table-id': 'Select custom table',
        edit: 'Edit relation',
        empty: 'No relations found.',
        display: 'Display',
    },
    attachments: {
        title: 'Attachments',
    },
    graph: {
        title: 'Relations',
    },
    'configure-record': {
        'add-field': 'Add field',
        'edit-field': 'Edit field',
        'relation-fields': {
            title: 'Configure Relation Fields',
        },
        errors: {
            name: 'Record view name is required.',
            fields: 'At least one field is required.',
            relations: 'At least one relation is required.',
            'relation-fields': 'Relation fields are required.',
        },
        'confirm-delete': 'Are you sure you want to delete this configuration?',
    },
    'default-record-view': 'Show default view',
    'custom-record-view': 'Show {name}',
    'configure-graph': {
        title: 'Configure Graph',
        nodes: 'Nodes',
        links: 'Links',
        fields: 'Visible fields',
        errors: {
            'no-tables': 'No tables defined in the workspace.',
            fields: 'At least one field is required.',
        },
        'confirm-delete': 'Are you sure you want to delete this configuration?',
    },
}
